import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
// import { AuthenticationService, SharedService } from '../_services/index';
// import { Globals } from '../_globals/globals';
import { OAuthService } from 'angular-oauth2-oidc';;
import { OauthPlusService } from '../services/oauth-plus.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private oauthService: OAuthService,
    private oauthPlusService: OauthPlusService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.oauthPlusService.canActivateProtectedRoutes$
      .pipe(
        map(isLogged => this.handleLoggedIn(isLogged, state)),
        switchMap(async _ => await this.handleRouter(route, state))
      );
  }

  handleLoggedIn(isLogged: boolean, state: any) {
    if (!isLogged) {
      this.oauthService.initLoginFlow(state.url)
      return false;
    }
    return true;
  }

  async handleRouter(route: any, state: any) {
    return true;  
    //logic implementation to restrict routes
  }
}
